import slugify from 'slugify';

export default function transformToSlug(phrase: string) {
  return slugify(phrase).toLocaleLowerCase();
}

export function deslugify(phrase: string) {
  return phrase.replace(/-/gi, ' ').trim();
}
